import React, { useState, useEffect } from 'react';

export default function FloatingButtons() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="floating-group">
      <a
        href="https://wa.me/918287450060"
        target="_blank"
        rel="noopener noreferrer"
        className="float-btn float-wa"
        aria-label="WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
      <a
        href="tel:+918287908005"
        className="float-btn float-call"
        aria-label="Call"
      >
        <i className="fas fa-phone"></i>
      </a>
      <button
        className={`float-btn float-top${show ? ' show' : ''}`}
        onClick={toTop}
        aria-label="Back to top"
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </div>
  );
}
